import React from "react";
import { Prism as SyntaxHighlighterLib } from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/cjs/styles/prism";

interface SyntaxHighlighterProps {
  code: string;
  language?: string;
  showLineNumbers?: boolean;
  className?: string;
  fallbackClassName?: string;
}

/**
 * Enhanced syntax highlighting component using react-syntax-highlighter
 *
 * Features:
 * - Professional syntax highlighting for 150+ languages
 * - Supports line numbers toggle
 * - Follows HeroUI theme patterns for consistent styling
 * - Uses Prism.js engine for reliable highlighting
 */
export const SyntaxHighlighter: React.FC<SyntaxHighlighterProps> = ({
  code,
  language = "text",
  showLineNumbers = false,
  className = "",
  fallbackClassName: _fallbackClassName, // Not used with react-syntax-highlighter, kept for interface compatibility
}) => {
  return (
    <div
      className={`syntax-highlighter bg-white dark:bg-default-50 rounded border border-default-200 dark:border-default-700 overflow-hidden ${className}`}
    >
      <SyntaxHighlighterLib
        customStyle={{
          margin: 0,
          padding: "1rem",
          fontSize: "0.875rem",
          fontFamily: "ui-monospace, SFMono-Regular, monospace",
          backgroundColor: "transparent",
          border: "none",
          borderRadius: 0,
        }}
        data-testid="syntax-highlighter"
        language={language}
        lineNumberStyle={{
          minWidth: "3rem",
          paddingRight: "1rem",
          marginRight: "1rem",
          borderRight: "1px solid #e5e7eb",
          color: "#9ca3af",
          backgroundColor: "transparent",
          userSelect: "none",
        }}
        showLineNumbers={showLineNumbers}
        style={tomorrow}
      >
        {code}
      </SyntaxHighlighterLib>
    </div>
  );
};
